<template>
  <div id="base-review-actions">
    <div class="m-common__review__action">
      <p v-if="isRenderHelpful && !isSelfReview" class="review__action__avail">このレビューは役立ちましたか？<br><button :class="{ active: isActiveHelpful }" @click="onClickHelpful">役に立った</button></p>
      <ul v-if="isRenderClip || isRenderModal">
        <li v-if="isRenderClip" class="review__action__clip lsf-icon clip"
          :class="{ active: isActiveClip }" @click="onClickClip"></li>
        <li v-if="isRenderModal" class="review__action__option lsf-icon etc"></li>
        <li v-if="isRenderModal" class="review__action__balloon">
          <ul class="review__action__menu">
            <li class="review__action__menu-delete" :data-remodal-target="remodalId" v-if="isLoginUsersReview">
              <span>レビューを削除する</span>
            </li>
            <li class="review__action__menu-report" v-else>
              <a @click="onClickReport">不適切なレビューを報告する</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <!-- https://github.com/vodkabears/Remodal -->
    <div v-if="isRenderModal" class="remodal-bg"></div>
    <div v-if="isRenderModal" class="remodal remodal__menu" :data-remodal-id="remodalId">
      <h3>このレビューを削除しますか？</h3>
      <p>一度削除すると元に戻すことはできません。</p>
      <button data-remodal-action="confirm" class="remodal-confirm" @click="onClickDelete">削除する</button>
      <button data-remodal-action="cancel" class="remodal-cancel">キャンセル</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import loadings from '@/mixins/loadings'
import errors from '@/mixins/errors'
import urls from '@/mixins/urls'
export default {
  name: 'BaseReviewActions',
  mixins: [ loadings, errors, urls ],
  props: {
    reviewId: {
      type: Number,
      required: true
    },
    helpfulId: {
      type: Number,
      default: undefined
    },
    clipId: {
      type: Number,
      default: undefined
    },
    isEntryHelpful: {
      type: Number,
      default: 0 // 0:役に立った未登録
    },
    isEntryClip: {
      type: Number,
      default: 0 // 0:クリップ未登録
    },
    nickname: {
      type: String,
      default: ''
    },
    selfFlag: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      remodalOptions: {
        hashTracking: false
      }
    }
  },
  computed: {
    ...mapGetters({
      isRenderHelpful: 'storeReviews/isRenderHelpful',
      isRenderClip: 'storeReviews/isRenderClip',
      isRemovedOnUnclip: 'storeReviews/isRemovedOnUnclip',
      isRenderModal: 'storeReviews/isRenderModal',
      cookies: 'commons/cookies',
      loginUser: 'storeUsers/user'
    }),
    isActiveHelpful () {
      return this.helpfulId !== undefined && this.isEntryHelpful === 1 // 1:役に立った登録済み
    },
    isActiveClip () {
      return this.clipId !== undefined && this.isEntryClip === 1 // 1:クリップ登録済み
    },
    remodalId () {
      return 'modal-' + this.reviewId
    },
    isLoginUsersReview () {
      const query = this.$store.state.storeReviews.query
      return query.isSelfSearch || (this.loginUser.nickname && this.loginUser.nickname === this.nickname)
    },
    reviewReportUrl () {
      return this.getReviewReportUrl(this.reviewId)
    },
    isSelfReview () {
      return this.selfFlag === '1'
    }
  },
  mounted () {
    this.initializeDeleteReportBalloon()
    this.initializeModal()
  },
  beforeDestroy () {
    this.destroyModal()
  },
  methods: {
    ...mapActions({
      deleteReview: 'storeReviews/deleteReview',
      registerHelpful: 'storeHelpfuls/registerHelpful',
      deleteHelpful: 'storeHelpfuls/deleteHelpful',
      clipReview: 'storeClips/clipReview',
      unclipReview: 'storeClips/unclipReview'
    }),
    // レビュー削除
    onClickDelete (e) {
      if (!this.validateAccessToken) {
        this.redirectAuth()
        return // 以降は処理しない
      }
      const target = e.currentTarget
      target.disabled = true // ダブルクリック抑止
      this.deleteReview({
        reviewId: this.reviewId
      })
      .then(data => {
        if (this.isAuthenticationError) {
          this.onAuthenticationError()
          return data
        }
        this.$emit('on-deleted', data) // 親画面へ通知
        return data
      })
      .catch(error => {
        alert(error.message)
        return Promise.resolve()
      })
      .then(data => {
        target.disabled = false
      })
      this.closeDeleteModal()
    },
    // レビュー報告
    onClickReport (e) {
      if (!this.validateAccessToken) {
        this.redirectAuth()
        return // 以降は処理しない
      }
      location.href = this.reviewReportUrl
    },
    // 役に立った
    onClickHelpful (e) {
      if (!this.validateAccessToken) {
        this.redirectAuth()
        return // 以降は処理しない
      }
      const target = e.currentTarget
      target.disabled = true // ダブルクリック抑止
      if (this.isActiveHelpful) {
        this.deleteHelpful({
          reviewId: this.reviewId,
          helpfulId: this.helpfulId
        }).catch(error => {
          alert(error.message)
          return Promise.resolve()
        }).then(data => {
          target.disabled = false
          if (this.isAuthenticationError) {
            this.onAuthenticationError()
          }
        })
      } else {
        this.registerHelpful({
          reviewId: this.reviewId
        }).catch(error => {
          alert(error.message)
          return Promise.resolve()
        }).then(data => {
          target.disabled = false
          if (this.isAuthenticationError) {
            this.onAuthenticationError()
          }
        })
      }
    },
    // クリップ
    onClickClip (e) {
      if (!this.validateAccessToken) {
        this.redirectAuth()
        return // 以降は処理しない
      }
      const target = e.currentTarget
      target.disabled = true // ダブルクリック抑止
      if (this.isActiveClip) {
        this.onUnclip(e)
      } else {
        this.clipReview({
          reviewId: this.reviewId
        }).catch(error => {
          alert(error.message)
          return Promise.resolve()
        }).then(data => {
          target.disabled = false
          if (this.isAuthenticationError) {
            this.onAuthenticationError()
          }
        })
      }
    },
    // クリップ解除
    // ※ここは直接呼ばれることはないためログイン遷移の確認処理は実施しない
    onUnclip (e) {
      const target = e.currentTarget
      target.disabled = true // ダブルクリック抑止
      this.unclipReview({
        reviewId: this.reviewId,
        clipId: this.clipId,
        isRemoved: this.isRemovedOnUnclip
      }).then(data => {
        if (this.isAuthenticationError) {
          this.onAuthenticationError()
        }
      }).catch(error => {
        alert(error.message)
        return Promise.resolve()
      }).then(() => {
        target.disabled = false
      })
    },
    initializeDeleteReportBalloon () {
      if (this.isRenderModal && window.$) {
        const $ = window.$
        $(document)
          .off('click.review-action-balloon')
          .on('click.review-action-balloon', function (e) {
            const balloon = '.review__action__balloon'
            const $target = $(e.target)
            if (!$target.next(balloon).length) {
              $(balloon).fadeOut()
            }
            if ($target.hasClass('review__action__option')) {
              $(balloon).fadeOut()
              $target.next(balloon).fadeIn()
            }
          })
      }
    },
    initializeModal () {
      if (this.isRenderModal && window.$) {
        window.$('[data-remodal-id="' + this.remodalId + '"]').remodal(this.remodalOptions)
      }
    },
    destroyModal () {
      if (window.$) {
        if (this.isRenderModal) {
          let $modal = window.$('[data-remodal-id="' + this.remodalId + '"]')
          if ($modal.length && $modal.remodal) {
            $modal.remodal().destroy()
          }
        }
      }
    },
    closeDeleteModal () {
      if (this.isRenderModal && window.$) {
        window.$('[data-remodal-id="' + this.remodalId + '"]').remodal().close()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseReviewActions.vue